export const formatRows = (listaItems) => 
  listaItems.map((item, index) => ({
    index: index + 1,  // Correctamente referenciando el índice
    id: item.ord_id || "Id no disponible",
    razon_social: 
    item?.cli_id === 1
      ? "Consumidor Final"
      : item?.razon_social?.trim() ? item.razon_social : "Nombre No Disponible",
    cli_name: 
    item?.cli_id === 1
      ? "Consumidor Final"
      : item?.cli_name?.trim() ? item.cli_name : "",
    createdAt: item.createdAt || "Fecha de creación no disponible",
    cli_direccion: item.cli_direccion || "Direccion no disponible",
    sel_fullname: 
      item["empleado_ord_his"]?.sel_lastname && item["empleado_ord_his"]?.sel_firstname 
      ? `${item["empleado_ord_his"]?.sel_lastname}, ${item["empleado_ord_his"]?.sel_firstname}`
      : item["empleado_ord_his"]?.sel_lastname || item["empleado_ord_his"]?.sel_firstname || "Sin Información",
    totalpedido: item.totalpedido || "0",
  }));
